import { render, staticRenderFns } from "./GuidedTour.vue?vue&type=template&id=6eb36281&scoped=true"
import script from "./GuidedTour.vue?vue&type=script&lang=js"
export * from "./GuidedTour.vue?vue&type=script&lang=js"
import style0 from "./GuidedTour.vue?vue&type=style&index=0&id=6eb36281&prod&lang=css"
import style1 from "./GuidedTour.vue?vue&type=style&index=1&id=6eb36281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb36281",
  null
  
)

export default component.exports